import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnDestroy,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';
import { ITaskV2 } from '@fi-app/task-v2/fi-task-v2';
import { FiTaskV2HelperService } from '@fi-app/task-v2/fi-task-v2-helper.service';
import { FiTasksViewMode } from '@fi-shared/fi-task-shared/fi-task-enums';
import { FiTaskSyncService } from '@fi-shared/fi-task-shared/fi-task-sync-service';
import { Subject } from 'rxjs';
import { FiTaskStatusType } from '@fi-app/task-v2/fi-task-v2-enums';
import { FiTaskStatusesConfig } from '@fi-app/task-v2/fi-task-v2-consts';

@Component({
    selector: 'fi-task-v2-status',
    templateUrl: './task-v2-status.component.html',
    styleUrls: ['./task-v2-status.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-task-v2-status' },
    standalone: false,
})
export class TaskV2StatusComponent implements OnInit, OnDestroy {
    @Input({ required: true }) task: ITaskV2;
    @Input() isAutomatedTask: boolean;

    protected readonly FiTaskStatusesConfig = FiTaskStatusesConfig;

    constructor(
        private fiTaskV2HelperService: FiTaskV2HelperService,
        private fiTaskSyncService: FiTaskSyncService,
        private cdr: ChangeDetectorRef,
    ) {}

    public ngOnInit(): void {
        this.subscribeToSyncTasks();
    }

    private subscribeToSyncTasks() {
        this.fiTaskSyncService.subscribeToTaskUpdatedBySync(this.task.Id, this.ngOnDestroy$, (updatedTask) => {
            this.fiTaskSyncService.updateTaskProps(this.task, updatedTask);
            this.cdr.markForCheck();
        });
    }

    protected onStatusChange(newStatus: FiTaskStatusType): void {
        this.fiTaskV2HelperService.emitTaskStatusChange(this.task, newStatus);
    }

    protected getViewMode(): FiTasksViewMode | undefined {
        if (this.task.Status === FiTaskStatusType.Cancelled) {
            return FiTasksViewMode.cancelled;
        }
        return undefined;
    }

    private ngOnDestroy$ = new Subject<void>();
    ngOnDestroy() {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }
}
